<script setup lang="ts">
import { onMounted, ref } from 'vue'

import { siteApi } from '@/api/client'
import type { SiteInfo } from '@/api/types'
import ThemeToggle from '@/components/ThemeToggle.vue'
import { useNoticeStore } from '@/stores/notice'

const site = ref<SiteInfo>({ name: '图书馆', subtitle: '记录技术、阅读与生活', description: '', url: '' })
const notice = useNoticeStore()

onMounted(async () => {
  try {
    site.value = await siteApi.get()
  } catch (cause) {
    notice.show(cause instanceof Error ? cause.message : '站点信息加载失败', 'error')
  }
})
</script>

<template>
  <header class="public-header">
    <RouterLink class="brand" to="/">
      <strong>{{ site.name }}</strong>
      <span>{{ site.subtitle }}</span>
    </RouterLink>
    <nav aria-label="主导航">
      <RouterLink to="/articles">文章</RouterLink>
      <RouterLink to="/tools">工具箱</RouterLink>
      <ThemeToggle />
    </nav>
  </header>
</template>
